import { createSlice } from "@reduxjs/toolkit";
import {
  organisationCreateMemberAction,
  organisationDeleteMemberAction,
  organisationMemberDetailsAction,
  organisationMembersListAction,
  organisationUpdateMemberAction,
  resetOrganisationAction,
} from "../Action/OrganisationAction";

const initialState = {
  dashboard: {},
  staff: [],
  memberOrganisations: [],
  members: [],
  memberDetails: {},
  membersMeta: {
    total: 0,
    page: 0,
    limit: 10,
    totalPages: 0,
  },
  lastMemberMutation: null,
};

const organisationSlice = createSlice({
  name: "organisation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetOrganisationAction, () => initialState)
      .addCase(organisationMembersListAction.fulfilled, (state, action) => {
        const payload = action?.payload?.data || action?.payload || {};
        const members =
          payload?.members ||
          payload?.memberList ||
          payload?.rows ||
          payload?.data ||
          [];

        state.members = Array.isArray(members) ? members : [];
        state.membersMeta = {
          total: payload?.total || 0,
          page: payload?.page || 0,
          limit: payload?.limit || 10,
          totalPages:
            payload?.totalPages ||
            Math.ceil((payload?.total || 0) / (payload?.limit || 10)),
        };
      })
      .addCase(organisationMemberDetailsAction.fulfilled, (state, action) => {
        state.memberDetails = action?.payload?.data || action?.payload || {};
      })
      .addCase(organisationCreateMemberAction.fulfilled, (state, action) => {
        state.lastMemberMutation = action?.payload || null;
      })
      .addCase(organisationUpdateMemberAction.fulfilled, (state, action) => {
        state.lastMemberMutation = action?.payload || null;
      })
      .addCase(organisationDeleteMemberAction.fulfilled, (state, action) => {
        state.lastMemberMutation = action?.payload || null;
      });
  },
});

export default organisationSlice.reducer;
